/**
 * Утилиты для работы с темой приложения
 */

/** 'platform' = следовать теме VK/Telegram; 'light'/'dark' = явный выбор пользователя */
export type Theme = 'light' | 'dark' | 'platform'

const THEME_STORAGE_KEY = 'app-theme'

export function getStoredTheme(): Theme | null {
  if (typeof window === 'undefined') return null
  const stored = localStorage.getItem(THEME_STORAGE_KEY)
  // migrate old 'system' value to 'platform'
  if (stored === 'system') {
    localStorage.setItem(THEME_STORAGE_KEY, 'platform')
    return 'platform'
  }
  return (stored as Theme) || null
}

export function setStoredTheme(theme: Theme): void {
  if (typeof window === 'undefined') return
  localStorage.setItem(THEME_STORAGE_KEY, theme)
}

export function getEffectiveTheme(theme: Theme, platformTheme: 'light' | 'dark' = 'light'): 'light' | 'dark' {
  if (theme === 'platform') return platformTheme
  return theme
}

export function applyTheme(theme: 'light' | 'dark'): void {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-theme', theme)
}

/**
 * Применяет тему при старте.
 * Порядок приоритетов: явное сохранённое (light/dark) → тема платформы (VK/Telegram).
 */
export function initializeTheme(
  platformTheme: 'light' | 'dark',
  _onThemeChange?: (theme: 'light' | 'dark') => void
): 'light' | 'dark' {
  const storedTheme = getStoredTheme()
  const effectiveTheme =
    storedTheme && storedTheme !== 'platform' ? storedTheme : platformTheme
  applyTheme(effectiveTheme)
  return effectiveTheme
}
